var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPeopleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0001 13.1001C18.5701 13.1001 16.6001 15.0701 16.6001 17.5001C16.6001 19.9302 18.5701 21.9001 21.0001 21.9001C23.4302 21.9001 25.4001 19.9302 25.4001 17.5001C25.4001 15.0701 23.4302 13.1001 21.0001 13.1001ZM14.4001 17.5001C14.4001 13.8551 17.3551 10.9001 21.0001 10.9001C24.6452 10.9001 27.6001 13.8551 27.6001 17.5001C27.6001 21.1452 24.6452 24.1001 21.0001 24.1001C17.3551 24.1001 14.4001 21.1452 14.4001 17.5001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90015 31.0001C8.90015 28.5926 10.8926 26.6001 13.3001 26.6001H28.7001C31.1077 26.6001 33.1001 28.5926 33.1001 31.0001V36.0001H30.9001V31.0001C30.9001 29.8077 29.8926 28.8001 28.7001 28.8001H13.3001C12.1077 28.8001 11.1001 29.8077 11.1001 31.0001V36.0001H8.90015V31.0001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.627 11.4863C31.9155 12.4499 33.6001 14.7369 33.6001 17.5001C33.6001 20.1518 31.9265 22.5457 29.627 23.5139L28.7733 21.4863C30.2738 20.8546 31.4001 19.2485 31.4001 17.5001C31.4001 15.6634 30.2848 14.1504 28.7733 13.5139L29.627 11.4863Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7001 26.6001C37.1077 26.6001 39.1001 28.5926 39.1001 31.0001V36.0001H36.9001V31.0001C36.9001 29.8077 35.8926 28.8001 34.7001 28.8001V26.6001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeopleLight);
export default __webpack_public_path__ + "static/media/icon_people_light.169c0f16.svg";
export { ForwardRef as ReactComponent };